<template>
    <div class="table-user">
        <div class="table-user-header">
            <b-row class="pb-3">
                <search-field @searchValue="event => searchField(event)"/>
                <date-filters @dateFromAction="filterTable($event)" @dateToAction="filterTable($event)" />
            </b-row>
        </div>
        <div class="scroll-x">
            <table-element
                :table-busy-disabled="disabledTableBusy"
                :items="orders"
                :fields="fields"
                @sort="event => sortTable(event)">

                <select-filter slot="HEAD_service"
                               name="salesChannel-select-filter"
                               filterType="service"
                               slot-scope="data"
                               :options="options.salesChannel"
                               placeholder="E-commerce"
                               @filtered="event => filterTable(event)"
                />

                <sales-actions slot="actions"
                               slot-scope="data"
                               :order-id="data.item.id"
                               :updateList="getItems"
                               :error="getItemsError(data.item)"
                               @getDelivery="getOrderDelivery"
                />
                <template slot="service" slot-scope="data">
                    <img :src="`/static/brand/${data.item.service}.png`"
                         class="img-fluid shop-logo"
                         :alt="`image-${data.item.service}`">
                    <div class="text-secondary">{{data.item.sellerShopName}}</div>
                </template>

                <template slot="productsImg" slot-scope="data">
                    <div class="product-cell"
                        :class="{'table-danger': data.item.status[index] !== 'active' || !productAvailable(data.item, index)}"
                        v-for="(img, index) in data.item.productsImg"
                        :key="index"
                        @click="productAction(data.item, index)">
                        <img :src="img" alt="" class="img-fluid">
                    </div>
                </template>

                <template slot="name" slot-scope="data">
                    <div
                        class="product-cell"
                        :class="{'table-danger': data.item.status[index] !== 'active'  || !productAvailable(data.item, index)}"
                        v-for="(name, index) in data.item.name"
                        :key="index"
                        @click="productAction(data.item, index)">
                        <div class="d-inline-block text-truncate"
                             style="max-width: 450px;">
                            {{name}}
                        </div>
                    </div>
                </template>

                <template slot="sku" slot-scope="data">
                    <div
                        class="product-cell"
                        :class="{'table-danger': data.item.status[index] !== 'active' || !productAvailable(data.item, index)}"
                        v-for="(sku, index) in data.item.sku" :key="index"
                        @click="productAction(data.item, index)">
                            {{sku}}
                    </div>
                </template>

                <template slot="fnsku" slot-scope="data">
                    <div class="product-cell"
                        :class="{'table-danger': data.item.status[index] !== 'active' || !productAvailable(data.item, index)}"
                        v-for="(fnsku, index) in data.item.fnsku" :key="index"
                        @click="productAction(data.item, index)">
                        {{fnsku}}
                    </div>
                </template>

                <template slot="productQuantity" slot-scope="data">
                    <div class="product-cell"
                        :class="{'table-danger': data.item.status[index] !== 'active' || !productAvailable(data.item, index)}"
                        v-for="(productQuantity, index) in data.item.productQuantity" :key="index"
                        @click="productAction(data.item, index)">
                        {{productQuantity}}
                    </div>
                </template>

                <template slot="total" slot-scope="data">
                    <div class="product-cell"
                        :class="{'table-danger': data.item.status[index] !== 'active' || !productAvailable(data.item, index)}"
                        v-for="(total, index) in data.item.total" :key="index"
                        @click="productAction(data.item, index)">
                        {{total}}
                    </div>
                </template>

                <template slot="salesCurrencyCode" slot-scope="data">
                    <div class="product-cell"
                         :class="{'table-danger': data.item.status[index] !== 'active' || !productAvailable(data.item, index)}"
                         v-for="(currency, index) in data.item.currencyCode"
                         :key="index"
                         @click="productAction(data.item, index)">
                            {{currency}}
                    </div>
                </template>

                <template slot="orderParcels" slot-scope="data">
                    {{data.value.length}}
                </template>
                <template slot="productsEdit" slot-scope="data">
                    <div class="product-cell"
                        :class="{'table-danger': data.item.status[index] !== 'active' || !productAvailable(data.item, index)}"
                        v-for="(id, index) in data.item.productsId" :key="index"
                        @click="productAction(data.item, index)">
                            <b-button v-if="data.item.status[index] === 'suspended'"
                                size="sm"
                                variant="primary-user">Edit</b-button>
                            <b-button v-if="data.item.status[index] === 'inactive'"
                                size="sm"
                                variant="primary-user">Restock</b-button>
                    </div>
                </template>
            </table-element>
        </div>

        <div class="table-user-footer">
            <table-pagination
                v-if="settingsPaginationFromApi.total >= quantityProductOnPage"
                @paginateAction="updatePagination"
                :settings="settingsPaginationFromApi"
                :perPageArray="quantityProductVariations"/>
        </div>

        <b-modal
            hide-header
            hide-footer
            @hidden="closeModal"
            @hide="disabledTableBusy = false"
            @show="disabledTableBusy = true"
            id="product-edit-modal"
            size="xl">
                <SingleProduct @editProduct="editProductHandler" :productId="productId" />
        </b-modal>

        <shipping-plan-modal
            @hide="disabledTableBusy = false"
            @show="disabledTableBusy = true"
            :items="[...shippingPlanProduct]" />

        <order-delivery
            @hide="disabledTableBusy = false"
            @show="disabledTableBusy = true"
            @updateList="getItems"
            :id="idForDelivery"
            :minInsurancePrice="minInsurancePrice"
            :preferableDelivery="preferableDelivery"
            :orderAddress="orderAddress"
            :showLockers="showLockers" />
    </div>
</template>

<script>
    import {tableMixins, paginationMixin, routePaginationMixin} from '@/mixins/tableMixins'
    import {startFulfillment} from '@/mixins/startFulfillment'

    import TableElement from '~cp/UserPanel/Elements/TableElement'
    import SearchField from '~cp/UserPanel/Elements/SearchField'
    import DateFilters from '~cp/UserPanel/Elements/DateFilters'
    import SelectFilter from '~cp/UserPanel/Elements/TableSelectField'
    import SalesActions from '~cp/UserPanel/Pages/Orders/SalesActions'

    import TablePagination from '~cp/UserPanel/Elements/TablePagination'

    import ordersSales from '@/assets/js/columns/ordersSales'
    import {ordersList as ordersFilterOptions} from '@/assets/js/table-options/orders'

    export default {
        name: 'OrderSales',
        mixins: [tableMixins, paginationMixin, routePaginationMixin, startFulfillment],
        components: {
            TableElement,
            SearchField,
            DateFilters,
            SelectFilter,
            SalesActions,
            TablePagination,
            SingleProduct: () => import('~user-pages/Inventory/SingleProduct'),
            ShippingPlanModal: () => import('~cp/UserPanel/Modals/ShippingPlanModal')
        },
        data () {
            return {
                productId: '',
                productWasEdit: false,
                shippingPlanProduct: {},
                disabledTableBusy: false,
                endpoint: this.$endpoints.orders.list,
                options: ordersFilterOptions,
                fields: ordersSales,
                requiredApiParams: {
                    'filter[status:in]': 'new',
                    'filter[service:not]': 'boxiti',
                    'filter[fulfillment]': 'false',
                    'sort[createdAt]': 'desc'
                },
                products: []
            }
        },
        computed: {
            productAvailable() {
                return (data, index) => {
                    return data.productQuantity[index] <= data.available[index]
                }
            }
        },
        created () {
            // TODO: waiting API
            // this.apiParams = Object.assign(this.apiParams, {
            //     'filter[status:in]': 'paid',
            //     'filter[status:in]': 'unshipped'
            // })
        },
        methods: {
            closeModal () {
                this.productId = ''
                if (this.productWasEdit) {
                    this.getItems()
                    this.productWasEdit = false
                }
            },
            productAction(order, productIndex) {
                let productStatus = order.status[productIndex]
                let productId = order.productsId[productIndex]
                if (productStatus === 'suspended') {
                    this.productEdit(productId)
                }
                if (productStatus === 'inactive') {
                    this.openPlanModal(order.id, productIndex)
                }
            },
            productEdit(id) {
                this.productId = id
                this.$root.$emit('bv::show::modal', 'product-edit-modal')
            },
            openPlanModal(orderId, index) {
                let order = this.orders.find(item => item.id === orderId)
                this.shippingPlanProduct = {
                    id: order.productsId[index],
                    quantity: order.productQuantity[index]
                }
                this.$root.$emit('bv::show::modal', 'shipping-plan-modal')
            },
            setItems() {
                let items = []
                this.items.forEach(order => {
                    items.push({
                        id: order.id,
                        uniqueNumber: order.uniqueNumber,
                        buyer: order.address && order.address.fullName ? order.address.fullName : '',
                        country: order.address && order.address.country ? order.address.country.nameEn : '',
                        address: order.address,
                        createdAt: order.createdAt,
                        service: order.service,
                        sellerShopName: order.sellerShopName,
                        customerPreferableDelivery: order.customerPreferableDelivery,
                        owner: order.owner,
                        ...this.getProductProps(order)
                    })
                })
                return items
            },
            getProductProps(order) {
                let props = {
                    name: [],
                    sku: [],
                    fnsku: [],
                    productQuantity: [],
                    total: [],
                    currencyCode: [],
                    productsImg: [],
                    status: [],
                    productsId: [],
                    available: []
                }
                order.orderedProducts.forEach(product => {
                    props.name.push(product.product.name)
                    props.sku.push(product.product.sku)
                    props.fnsku.push(product.product.fnsku)
                    props.productQuantity.push(product.orderedQuantity)
                    props.total.push(product.orderedQuantity * product.product.price)
                    props.currencyCode.push(product.product.currencyCode)
                    let url = ''
                    if (product.product.images.length > 0) {
                        url = product.product.images[0].imageUrl
                    }
                    props.productsImg.push(url)
                    props.status.push(product.product.status)
                    props.productsId.push(product.product.id)
                    props.available.push(product.product.stock.available)
                })
                return props
            },
            editProductHandler() {
                this.productWasEdit = true
                this.$root.$emit('bv::hide::modal', 'product-edit-modal')
            },
        }
    }
</script>

<style lang="scss" scoped>
    .table-user {
        min-height: 300px;
        .scroll-x {
            min-height: calc(100vh - 300px);
        }
        .shop-logo {
            max-height: 80px;
        }
    }
    .product-cell {
        .img-fluid {
            max-height: 100%;
        }
        display: flex;
        height: 80px;
        padding: 10px;
        align-items: center;
        justify-content: center;
        &:not(:first-child) {
            border-top: 1px solid #dee2e6;
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/UserPanel/Pages/Orders/Sales.vue